export default "__VITE_ASSET__Bzcqau5G__"